module.exports = __webpack_public_path__ + "img/22 ayuda.a02475b2.jpg";